export default __webpack_public_path__ + "static/media/Bg5-1.f89cb2a0.png";